import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorModule } from '@pc-ui/error/error.module';
import { RadioComponent } from './radio.component';

@NgModule({
  declarations: [RadioComponent],
  imports: [CommonModule, ErrorModule, ReactiveFormsModule],
  exports: [RadioComponent],
})
export class RadioModule {}
